export const CNIL = 'CNIL';
export const EMAIL = 'EMAIL';
export const SMS = 'SMS';
export const MAIL = 'MAIL';
export const CGV = 'CGV';
export const IDENTITY_NUMBER = 'IDENTITY_NUMBER';
export const PHONE = 'PHONE';
export const PROFILING = 'PROFILING';
export const FOSUN_PARTNERS = 'FOSUN_PARTNERS';
export const CLUBMED_PLUS = 'CLUBMED_PLUS';
export const THEO = 'WEBTHEO';
export const PASSPORT = 'PASSPORT';
export const IDCARD = 'IDCARD';
// right now we only manage these two document types
export const DOCUMENT_TYPES = [PASSPORT, IDCARD];
